import { useContext, useState } from 'react';
import { WP_Place } from '../model/map/map';
import { useLogger } from '../services/LogService';
import { AppContext } from '../state/AppContextProvider';
import { useWP } from './WPHooks';
import { Map, tileLayer, marker, divIcon } from 'leaflet';
import { useHistory } from 'react-router';

export const useLeafLet = (placesCategories, tagId) => {
  const { state } = useContext(AppContext);

  const { wp } = useWP();

  const history = useHistory();

  const logger = useLogger('LeafLetMap');

  const [map, setMap] = useState<any>(undefined);

  const [initialPlacesList, setInitialPlaces] = useState<Array<WP_Place>>([]);
  const [placesList, setPlaces] = useState<Array<WP_Place>>([]);

  // Initialize the leaflet map

  const initMap = () => {
    logger.info('Initialize the map');
    wp.getPlaces(state.locale).then((places) => {
      setInitialPlaces(places);
      // Check if we have tagId in url
      if (tagId !== undefined) {
        const placeSelectedFromUrl = places.find((place) => {
          return place.id === parseInt(tagId);
        });

        if (placeSelectedFromUrl) {
          setPlaces([placeSelectedFromUrl]);
          setSelectedPlace(placeSelectedFromUrl);
          setMarkerSelected(true);
        } else {
          setPlaces(places);
        }
      } else {
        setPlaces(places);
      }
    });

    const initLeaflet = () => {
      const leafletMap = new Map('leaflet-map').setView(
        [48.81907202982484, 2.3379099369049077],
        16
      );
      setMap(leafletMap);

      tileLayer(
        'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
        {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 22,
        }
      ).addTo(leafletMap);
    };

    initLeaflet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  // Create all markers

  const [currentSelectedPlace, setSelectedPlace] = useState<WP_Place>();
  const [allMarkers, setAllMarkers] = useState<WP_Place[]>([]);
  const [isMarkerSelected, setMarkerSelected] = useState<boolean>(false);

  const createMarkers = () => {
    logger.info('Adding markers to the map');

    if (placesList.length > 0) {
      allMarkers.map((m) => {
        return map.removeLayer(m);
      });

      setAllMarkers([]);

      const listMarkers: WP_Place[] = [];

      placesList.forEach((place) => {
        const markerCategory = place.acf.place_category[0];

        let currentMarkerCategoryColorDefined = '#47D7A7';
        if (markerCategory !== undefined) {
          const currentMarkerCategoryColor = placesCategories.find(
            (placeCategory) => placeCategory.id === markerCategory.term_id
          );

          if (currentMarkerCategoryColor !== undefined) {
            currentMarkerCategoryColorDefined =
              currentMarkerCategoryColor.acf.category_place_color;
          }
        }

        const custom_icon = new divIcon({
          iconSize: [24, 36],
          iconAnchor: [12, 36],
          className: 'red',
          html:
            '<svg width="24" height="37" viewBox="0 0 24 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 17.6752 15.2 31.8096 12.6736 35.76C12.6012 35.873 12.5016 35.9659 12.3839 36.0303C12.2662 36.0947 12.1342 36.1284 12 36.1284C11.8658 36.1284 11.7338 36.0947 11.6161 36.0303C11.4984 35.9659 11.3988 35.873 11.3264 35.76C8.8 31.8112 0 17.6752 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0Z" fill="' +
            currentMarkerCategoryColorDefined +
            '"/><path d="M11.9992 16.7998C14.6502 16.7998 16.7992 14.6508 16.7992 11.9998C16.7992 9.34886 14.6502 7.19983 11.9992 7.19983C9.34825 7.19983 7.19922 9.34886 7.19922 11.9998C7.19922 14.6508 9.34825 16.7998 11.9992 16.7998Z" fill="white"/></svg>',
        });

        placesList.length === 1 &&
          map.setView(
            [
              place.acf.place_coordinates.markers[0]['lat'],
              place.acf.place_coordinates.markers[0]['lng'],
            ],
            19
          );

        const m = marker(
          [
            place.acf.place_coordinates.markers[0]['lat'],
            place.acf.place_coordinates.markers[0]['lng'],
          ],
          { icon: custom_icon }
        )
          .addTo(map)
          .on('click', () => {
            setSelectedPlace(place);
            setMarkerSelected(true);
            map.setView(
              [
                place.acf.place_coordinates.markers[0]['lat'],
                place.acf.place_coordinates.markers[0]['lng'],
              ],
              19
            );
            history.push('/pages/map/' + place.id);
          });
        listMarkers.push(m);
      });
      setAllMarkers(listMarkers);
    }
  };

  const resetView = () => {
    map.setView([48.81907202982484, 2.3379099369049077], 16);
  };

  return {
    initMap: initMap,
    mapIsInit: map !== undefined ? true : false,
    resetView: resetView,
    createMarkers: createMarkers,
    setPlaces: setPlaces,
    initialPlacesList: initialPlacesList,
    placesList: placesList,
    currentSelectedPlace: currentSelectedPlace,
    isMarkerSelected: isMarkerSelected,
    setMarkerSelected: setMarkerSelected,
  };
};
